import React from "react";
import { withTranslation } from "react-i18next";
import { Form, DatePicker, Typography } from "antd";
import moment from "moment";

const { Text } = Typography;

const EstimatedDateFormItemComponent = ({
  t,
  style,
  title,
  required = false,
  editable = true,
  showLabel = false,
  strong = false,
  defaultValue,
  dataTMId,
  name = "estimatedDelivery",
  recordInfo
}) => (
  <Form.Item
    name={recordInfo ? [recordInfo.key, recordInfo.dataIndex] : name}
    label={
      showLabel ? (
        <Text strong={strong} style={{ color: "#9B9B9B" }}>
          {title ? title : t("form.estimated_date.label")}
        </Text>
      ) : null
    }
    style={style}
    colon={false}
    rules={[{ required, message: t("form.estimated_date.error_required") }]}
  >
    {editable ? (
      <DatePicker
        style={{ width: "100%" }}
        placeholder={t("form.estimated_date.placeholder")}
        disabled={!editable}
        format={"MM/DD/YYYY"}
        allowClear={true}
      />
    ) : (
      <Text data-tm-id={dataTMId}>{defaultValue ? `${moment(defaultValue).format("MM/DD/YYYY")}` : "-"}</Text>
    )}
  </Form.Item>
);

const EstimatedDateFormItem = withTranslation()(EstimatedDateFormItemComponent);

export { EstimatedDateFormItem };
